import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FieldType } from '@ngx-formly/material';
import { DocumentDto } from 'projects/shared/src/lib/models/DocumentDto';
import { AttributeValueService } from 'projects/shared/src/lib/services/attribute-value.service';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'al-textarea-type',
  templateUrl: './al-textarea-type.component.html',
  styleUrls: ['./al-textarea-type.component.scss']
})
export class AlTextareaTypeComponent extends FieldType implements OnInit {

  @ViewChild('autosize')
  autosize!: CdkTextareaAutosize;

  documentDto!: DocumentDto;

  totalRecords = 0;
  currentPage = 1;
  pageSize = 10

  dbName!: string;
  pageId!: string;
  documentId!: string;
  controlfield!: string;

  get type() {
    return this.to.type || 'text';
  }

  constructor(private _ngZone: NgZone,
    private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private attributeValueService: AttributeValueService) {
    super();
  }

  override ngOnInit(): void {
    this.dbName = localStorage.getItem('dbname') as string;

    this.dataSharingService.tabIdChanges$.subscribe({
      next: (pageId: any) => {
        this.pageId = pageId as string;
      }
    })

    this.documentId = localStorage.getItem('doc-id') as string;
    this.pageId = localStorage.getItem('page-id') as string;

    this.attributeValueService.loadCurrentAttributeValue('', this.documentId, this.pageId, this.currentPage, this.pageSize, this.dbName).subscribe({
      next: (currentAttributeValueDto: any) => {
        console.log(currentAttributeValueDto.controlData)
        this.model = JSON.parse(currentAttributeValueDto.controlData);
      },
      //error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    //this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  valueChangeFn(key: any, id: any, event: any) {
    let formData:any = {};
    formData[key] = event.target.value;

    this.attributeValueService.createAttributValueInfo(this.documentId, this.pageId, formData, key, id, this.dbName).subscribe({
      next: (data :any) => {
        console.log(data)
      },
      // error: error => this.errorMessage = ErrorFormat.formatError(error)
    });
  } 
}
